import CopyToClipboard from 'react-copy-to-clipboard/lib';
import toast from 'react-hot-toast';
import iconCopy from '../../../dashboard/assets/Icon_copy_address.png';
import { CommonTimestamp } from '../../../../../utils/TimeUtils';
import React from 'react';

export const TRANSFER_COLGROUP = [1, 1.1, 1, 1, 1.3];
export const TRANSFER_HEADERS = [
  { title: 'TX Hash', accessor: 'tx_hash' },
  { title: 'Date', accessor: 'timestamp' },
  { title: 'From', accessor: 'sender' },
  { title: 'To', accessor: 'receiver' },
  { title: 'Amount', accessor: 'amount' },
];
export const TRANSFER_RENDERER = (data: any) => {
  return {
    tx_hash: (
      <div style={{ display: 'flex', gap: 10 }}>
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={data.tx_hash}
        >
          {data.tx_hash}
        </div>
        <CopyToClipboard text={data.tx_hash} onCopy={() => toast('Copied TX Hash', { icon: '👏' })}>
          <img src={iconCopy} alt="copy" style={{ width: 20, height: 20, objectFit: 'contain', cursor: 'pointer' }} />
        </CopyToClipboard>
      </div>
    ),
    timestamp: data.timestamp,
    sender: (
      <div style={{ display: 'flex', gap: 10 }}>
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={data.sender}
        >
          {data.sender}
        </div>
        <CopyToClipboard text={data.sender} onCopy={() => toast('Copied Sender Address', { icon: '👏' })}>
          <img src={iconCopy} alt="copy" style={{ width: 20, height: 20, objectFit: 'contain', cursor: 'pointer' }} />
        </CopyToClipboard>
      </div>
    ),
    receiver: (
      <div style={{ display: 'flex', gap: 10 }}>
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={data.receiver}
        >
          {data.receiver}
        </div>
        <CopyToClipboard text={data.receiver} onCopy={() => toast('Copied Receiver Address', { icon: '👏' })}>
          <img src={iconCopy} alt="copy" style={{ width: 20, height: 20, objectFit: 'contain', cursor: 'pointer' }} />
        </CopyToClipboard>
      </div>
    ),
    amount: data.amount,
  };
};

export const APPROVAL_COLGROUP = [1, 1.1, 1, 1, 1.3];
export const APPROVAL_HEADERS = [
  { title: 'TX Hash', accessor: 'tx_hash' },
  { title: 'Date', accessor: 'timestamp' },
  { title: 'Approver', accessor: 'approver' },
  { title: 'Spender', accessor: 'spender' },
  { title: 'Allowance', accessor: 'allowance' },
];
export const APPROVAL_RENDERER = (data: any) => ({
  tx_hash: (
    <div style={{ display: 'flex', gap: 10 }}>
      <div title={data.tx_hash}>{data.tx_hash}</div>
      <CopyToClipboard text={data.tx_hash} onCopy={() => toast('Copied TX Hash', { icon: '👏' })}>
        <img src={iconCopy} alt="copy" style={{ width: 20, height: 20, objectFit: 'contain', cursor: 'pointer' }} />
      </CopyToClipboard>
    </div>
  ),
  timestamp: data.timestamp,
  approver: data.approver,
  spender: data.operator,
  allowance: data.is_approved ? 'Approved' : 'Rejected',
});

export const HOLDER_COLGROUP = [1, 1, 2, 1];
export const HOLDER_HEADERS = [
  { title: 'Holder', accessor: 'holder_id' },
  { title: 'Token ID', accessor: 'token_id' },
  { title: 'Address', accessor: 'address' },
  { title: 'Balance', accessor: 'balance' },
];
export const HOLDER_RENDERER = (data: any) => ({
  holder_id: data.holder_id,
  token_id: data.token_id,
  address: data.address,
  balance: data.balance,
});

export const ENTRANCES_COLGROUP = [1, 2, 2, 1, 1];
export const ENTRANCES_HEADERS = [
  { title: 'Entrance ID', accessor: 'entrance_id' },
  { title: 'Entrance Name', accessor: 'entrance_name' },
  { title: 'Entrance Hash', accessor: 'entrance_hash' },
  { title: 'Expiration Time', accessor: 'expiration_time' },
  { title: 'Location', accessor: 'location' },
];
export const ENTRANCES_RENDERER = (data: any) => ({
  entrance_id: data.entrance_id,
  entrance_name: data.entrance_name,
  entrance_hash: data.entrance_hash,
  expiration_time: data.expiration_time || '-',
  location: data.location || '-',
});

export const GET_ROLES_COLGROUP = [6.5, 1];
export const GET_ROLES_HEADERS = [
  { title: 'Address', accessor: 'address' },
  { title: 'Grade', accessor: 'role' },
];
export const GET_ROLES_RENDERER = (data: any) => {
  return {
    address: data.address,
    role: data.role,
  };
};

export const GET_ENTRANCES_COLGROUP = [1, 1, 1, 1];
export const GET_ENTRANCES_HEADERS = [
  { title: 'Token ID', accessor: 'token_id' },
  { title: 'Authorizer Address', accessor: 'authorizer_address' },
  { title: 'Transaction Hash', accessor: 'transaction_hash' },
  { title: 'Date', accessor: 'timestamp' },
];
export const GET_ENTRANCES_RENDERER = (data: any) => {
  return {
    token_id: data.token_id,
    authorizer_address: data.authorizer_address,
    transaction_hash: data.transaction_hash,
    timestamp: CommonTimestamp(data.timestamp),
  };
};

export const TRANSFER_HISTORY_ID = 2030;
export const APPROVAL_HISTORY_ID = 4030;
export const HOLDERS_ID = 1050;
export const ENTRANCES_ID = 40300;
export const GET_ROLES_ID = 3040;
export const GET_ENTRANCES_ID = 4080;

export const TABLE_RESULT_IDS = [TRANSFER_HISTORY_ID, APPROVAL_HISTORY_ID, HOLDERS_ID, ENTRANCES_ID, GET_ROLES_ID, GET_ENTRANCES_ID];
